import { createHttp } from "@/utils/axios";

const { VITE_SERVER_LANDWORK } = import.meta.env;
const http = createHttp({
  baseURL: VITE_SERVER_LANDWORK,
});

// 根据任务id获取权限列表
export const permissionList = (bizId: string) => {
  return http.post(`/permission/list/${bizId}`);
};
